<template>
  <div>
    <loading-spinner v-if="!subdistributor" />
    <app-header
      v-if="subdistributor"
      :title="originalName ? editTitle : newTitle"
    >
      <template #col-right>
        <b-button variant="primary" type="submit" class="mr-1" @click="save">
          <span v-label-key="'SAVE_CHANGES'">Save Changes</span>
        </b-button>
        <cancel-button />
      </template>
    </app-header>

    <b-container v-if="subdistributor && distributors">
      <b-row>
        <b-col md="6">
          <errors v-if="errors.length" :errors="errors" />
          <b-form ref="editorForm">
            <b-form-group
              :label="`${getLabel('DISTRIBUTOR')} *`"
              :description="
                getLabel('EDIT_SUBDISTRIBUTOR_DISTRIBUTOR_DESCRIPTION')
              "
            >
              <b-form-select
                v-model="subdistributor.distributor_id"
                class="form-control"
                required
              >
                <b-form-select-option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor.id"
                >
                  {{ distributor.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              :label="`${getLabel('NAME')} *`"
              :description="getLabel('EDIT_SUBDISTRIBUTOR_NAME_DESCRIPTION')"
            >
              <b-form-input
                v-model="subdistributor.name"
                type="text"
                class="form-control"
                required
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $auth from '@/services/auth';
import CancelButton from '@/components/CancelButton';
import LoadingSpinner from '@/components/LoadingSpinner';
import Errors from '@/components/Errors';
import AppHeader from '@/components/AppHeader';
import { mapGetters } from 'vuex';

export default {
  components: {
    CancelButton,
    LoadingSpinner,
    Errors,
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
      getReplaceLabel: 'getReplaceLabel',
    }),
    editTitle() {
      return this.getReplaceLabel('EDIT_ITEM_NAME', {
        '{NAME}': this.originalName,
      });
    },
    newTitle() {
      return this.getReplaceLabel('NEW_ITEM_NAME', {
        '{NAME}': this.getLabel('SUBDISTRIBUTOR'),
      });
    },
  },
  data() {
    return {
      errors: [],
      auth: $auth,
      originalName: null,
      subdistributor: null,
      distributors: null,
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      $api.get('/v1/dashboard/distributors').then(distributors => {
        this.distributors = distributors.data;
      });
      if (this.$route.query.id) {
        $api
          .get(`/v1/dashboard/subdistributors/${this.$route.query.id}`)
          .then(subdistributor => {
            this.originalName = subdistributor.name;
            this.subdistributor = subdistributor;
          });
      } else {
        this.subdistributor = {
          distributor_id:
            this.$route.query.distributor_id ||
            $auth.user.selectedAccess.distributor_id,
        };
      }
    },
    validateForm() {
      this.errors = [];

      if (!this.subdistributor.distributor_id) {
        this.errors.push(
          this.getLabel('FORM_ERROR_DISTRIBUTOR_REQUIRED') ||
            'The distributor field is required.'
        );
      }

      if (!this.subdistributor.name) {
        this.errors.push(
          this.getLabel('FORM_ERROR_NAME_REQUIRED') ||
            'The name field is required.'
        );
      }
    },
    save() {
      if (!this.$refs.editorForm.checkValidity()) {
        this.$refs.editorForm.reportValidity();
        this.validateForm();
        return;
      }
      this.errors = [];
      if (this.subdistributor.id) {
        $api
          .put(
            `/v1/dashboard/subdistributors/${this.subdistributor.id}`,
            this.subdistributor
          )
          .then(subdistributor => {
            this.$router.push({
              name: 'subdistributor-detail',
              params: subdistributor,
            });
          });
      } else {
        $api
          .post('/v1/dashboard/subdistributors', this.subdistributor)
          .then(subdistributor => {
            this.$router.push({
              name: 'subdistributor-detail',
              params: subdistributor,
            });
          });
      }
    },
  },
};
</script>
